import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { Parking, ParkingStatus, parkingsPath } from '@parkupp/core'
import { collection, collectionData, query, where, orderBy, limit } from '@angular/fire/firestore'
import { Firestore } from '@angular/fire/firestore'
import { Subscription } from 'rxjs'
import { take } from 'rxjs/operators'

@Component({
    selector: 'app-redefine-homepage',
    templateUrl: './redefine-homepage.component.html',
    styleUrls: ['./redefine-homepage.component.scss'],
})
export class RedefineHomepageComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = []

    // Featured properties
    featuredParkings: Parking[] = []
    loadingParkings = true

    // Stats
    stats = {
        properties: 0,
        parkingBays: 0,
        occupancyRate: 94,
    }

    constructor(private router: Router, private firestore: Firestore) {}

    ngOnInit(): void {
        this.loadFeaturedParkings()
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe())
    }

    loadFeaturedParkings(): void {
        this.loadingParkings = true

        // Query parkings for Redefine enterprise
        const parkingsRef = query(
            collection(this.firestore, parkingsPath()),
            where('parkingStatus', '==', ParkingStatus.PUBLISHED),
            where('denormEnterpriseKey', '==', 'redefine'),
            orderBy('createdAt', 'desc'),
            limit(6)
        )

        const sub = collectionData(parkingsRef, { idField: '$key' })
            .pipe(take(1))
            .subscribe((parkings: any[]) => {
                this.featuredParkings = parkings.map((p) => new Parking(p))

                // Calculate stats
                this.stats.properties = parkings.length
                this.stats.parkingBays = parkings.reduce((sum, p) => sum + (p.numberOfBays || 0), 0)

                this.loadingParkings = false
            })

        this.subscriptions.push(sub)
    }

    viewProperty(parking: Parking): void {
        this.router.navigate(['/parking', parking.$key])
    }

    viewAllProperties(): void {
        // No query param needed - map page detects enterprise from domain
        this.router.navigate(['/map-search'])
    }

    contactUs(): void {
        this.router.navigate(['/contact'])
    }

    formatPrice(priceInCents: number): string {
        if (!priceInCents) return 'Price on request'
        return `R${(priceInCents / 100).toLocaleString('en-ZA')}`
    }

    getParkingImage(parking: Parking): string {
        // Try to get the primary image URL
        if (parking.imagePrimary && parking.images && parking.images[parking.imagePrimary]) {
            const image = parking.images[parking.imagePrimary]
            return image.largeUrl || image.mediumUrl || image.smallUrl || image.originalUrl || '/assets/images/parking/no_image.png'
        }
        // Fallback to first available image
        if (parking.images) {
            const firstKey = Object.keys(parking.images)[0]
            if (firstKey) {
                const image = parking.images[firstKey]
                return image.largeUrl || image.mediumUrl || image.smallUrl || image.originalUrl || '/assets/images/parking/no_image.png'
            }
        }
        return '/assets/images/parking/no_image.png'
    }

    scrollToSection(sectionId: string): void {
        const element = document.getElementById(sectionId)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }
}
